import React, { Component } from 'react';
import { Row, Col } from 'antd';

class UnauthorizedPage extends Component {
	render() {
		return (
			<Row>
				<Col span={16}>
					Unauthorized
				</Col>
			</Row>
		);
	}
}

export default UnauthorizedPage;
